/* Lorolivo: apply code and show updated cart totals in-place. */
(function () {
  'use strict';
  if (window.lorolivoCartDiscountInitialized) return;
  window.lorolivoCartDiscountInitialized = true;

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function moneyFromCents(cents, currency) {
    const locale = (document.documentElement.lang || 'es-ES').replace('_', '-');
    try {
      return new Intl.NumberFormat(locale, {style: 'currency', currency: currency || 'EUR'}).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  document.addEventListener('click', async function (event) {
    const button = event.target && event.target.closest ? event.target.closest('[data-lorolivo-apply-discount]') : null;
    if (!button) return;
    event.preventDefault();
    if (button.dataset.processing === 'true') return;

    const promo = button.closest('.lorolivo-welcome-cart');
    if (!promo) return;
    const status = promo.querySelector('[data-lorolivo-discount-status]');
    const subtotal = button.closest('#AjaxCartSubtotal');
    button.dataset.processing = 'true';
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Aplicando…';
    if (status) status.textContent = '';

    try {
      const response = await fetch(rootPath() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({discount: 'LOROLIVO10'})
      });
      const cart = await response.json();
      if (!response.ok || typeof cart.total_price !== 'number') {
        throw new Error('No se pudo actualizar el carrito');
      }

      const onCartPage = /\/cart\/?$/.test(window.location.pathname);
      if (onCartPage) {
        window.location.reload();
        return;
      }
      const sectionId = 'helper-cart';
      const currentPage = window.location.pathname + window.location.search;
      const separator = currentPage.includes('?') ? '&' : '?';
      const sectionUrl = currentPage + separator + 'section_id=' + sectionId;
      const sectionResponse = await fetch(sectionUrl, {credentials: 'same-origin', cache: 'no-store'});
      if (!sectionResponse.ok) throw new Error('No se pudo refrescar el resumen');
      let html = await sectionResponse.text();

      const verified = new DOMParser().parseFromString(html, 'text/html');
      const verifiedPromo = verified.querySelector('.lorolivo-welcome-cart');
      const saved = Number(verifiedPromo && verifiedPromo.getAttribute('data-lorolivo-discount-amount')) || 0;
      if (!(saved > 0)) {
        const verifiedStatus = verified.querySelector('[data-lorolivo-discount-status]');
        if (verifiedStatus) verifiedStatus.textContent = 'El código no reduce este carrito. Comprueba los productos incluidos o si ya hay otro descuento.';
        html = verified.body.innerHTML;
      }

      if (!onCartPage && typeof window.renderHelperCart === 'function') {
        window.renderHelperCart(html);
      } else {
        const fresh = new DOMParser().parseFromString(html, 'text/html');
        const newSubtotal = fresh.querySelector('#AjaxCartSubtotal');
        if (!newSubtotal || !subtotal) throw new Error('Falta el resumen actualizado');
        subtotal.innerHTML = newSubtotal.innerHTML;
        const oldItems = document.querySelector('.cart-section #AjaxCartForm');
        const newItems = fresh.querySelector('.cart-section #AjaxCartForm');
        if (oldItems && newItems && typeof oldItems.ajaxifyCartItems === 'function') {
          oldItems.innerHTML = newItems.innerHTML;
          oldItems.ajaxifyCartItems();
        }
      }
    } catch (err) {
      // Fallback to Shopify's native discount URL, which redirects to the cart.
      if (status) status.textContent = 'Actualizando el carrito…';
      window.location.assign(button.href);
    }
  });
})();